import React from "react";
import {InputChangeEventDetail, IonInput, IonItem, IonLabel} from "@ionic/react";

/**
 * Component displaying an input with a label.
 * @author Alizée Grand
 * @version 1.1
 * @creation 25/04/2022
 * @last_update 10/05/2022
 **/
class InputIdentification extends React.Component<{
    /**
     * Input label.
     */
    label: string,
    /**
     * Function called when the input value changes.
     * @param {string} newValue New input value.
     * @param {boolean} filledManually Specifies whether the field has been filled in manually or not.
     */
    onNewValue: (newValue: string, filledManually: boolean) => void,
    /**
     * Initial input value.
     */
    value?: string,
}> {

    state = {
        // Stores the number of times the field has been modified.
        count: 0
    }

    render() {

        /**
         * Function called when the input is modified.
         * Calls the eponymous function in props if the value entered is correct.
         * @param {CustomEvent<InputChangeEventDetail>} event
         */
        const setValue = (event: CustomEvent<InputChangeEventDetail>) => {
            const value = event.detail.value;
            if(value !== undefined && value !== null) {
                this.setState({
                    count: (this.state.count + 1)
                });
                // TODO: Permettre la modification même quand le champ est correct
                this.props.onNewValue(value, (this.state.count > 1));
            }
        }

        return (

            <IonItem>
                <IonLabel position="floating" color="secondary">
                    {this.props.label}
                </IonLabel>
                <IonInput
                    type="text"
                    value={this.props.value}
                    onIonChange={setValue}
                    placeholder="AEARF01234566"
                    clearInput
                />
            </IonItem>

        );

    };

}

export default InputIdentification;
